import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Application.List.IRequest;
type Response = Api.Core.Application.List.IResponse;
type Headers = Api.Core.Application.List.IHeaders;
const url = '/api/Management/Application';
export default async function applicationListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
